@if (linkedEquipment()) {
  <div class="mb-4 text-sm" role="status">Verknüpfte Komponente
    <a class="ml-2 underline" [routerLink]="[]" [queryParams]="{}">Alle Komponenten anzeigen</a>
  </div>
}
<div class="space-y-6">
  <!-- Modules Table -->
  <app-data-table
    [data]="visibleEquipment()"
    [columns]="columns"
    [rowActions]="actions"
    [isLoading]="isLoading()"
    [searchableFields]="['name', 'power', 'costs']"
    addNewLabel="Modul hinzufügen"
    [showAddButton]="currentOrgStore.can('organization', 'createequipment')"
    emptyStateTitle="Keine Module gefunden"
    emptyStateDescription="Fügen Sie Module hinzu oder synchronisieren Sie globale Module."
    (addNew)="addModule()"
  />

  <!-- Create Module Dialog -->
  <app-create-module-dialog
    #createDialog
    [editModule]="editingModule()"
    (submitted)="reloadModules()"
  />

  <!-- Templates -->
  <ng-template #moduleTpl let-module>
    <div class="text-sm">{{ module.name }}</div>
  </ng-template>

  <ng-template #performanceTpl let-module>
    <div class="text-right text-sm tabular-nums">{{ module.power | number: "1.0-3" }} kWp</div>
  </ng-template>

  <ng-template #sizeTpl let-module>
    <div class="space-y-1 text-sm">
      <div>{{ module.height }} × {{ module.width }} cm</div>
      <div class="text-xs text-muted-foreground">
        {{ (module.height * module.width) / 10000 | number: "1.2-2" }} m²
      </div>
    </div>
  </ng-template>

  <ng-template #efficiencyTpl let-module>
    <div class="text-right text-sm tabular-nums">{{ module.efficiencyLossPerYear | number: "1.0-2" }} % p.a.</div>
  </ng-template>

  <ng-template #costsTpl let-module>
    <div class="text-right text-sm tabular-nums">{{ module.totalCosts | number: "1.2-2" }} €</div>
  </ng-template>
</div>
